export enum DeviceOrientation {
  landscape = 'landscape',
  portrait = 'portrait'
}
